/**
 * Stops opt-in auto-advancing carousels from moving when the visitor has asked
 * for reduced motion.
 *
 * Horizon's `slideshow.js` has no `prefers-reduced-motion` handling of its own —
 * it reads the `autoplay` attribute and runs. Removing that attribute is enough
 * to disable it, because `autoplayInterval` reads the attribute lazily and
 * `resume()` bails when `autoplay` is falsy. The carousel stays fully usable:
 * arrows, swipe and keyboard all still work, it just doesn't move on its own.
 *
 * Deliberately scoped to `.fine-carousel-autoplay` (set by
 * `snippets/resource-list-carousel.liquid`) rather than every slideshow on the
 * page, so this does not silently change the hero's behaviour. Widening it to
 * all slideshows would arguably be more correct for accessibility, but that is
 * a separate decision.
 */
const query = window.matchMedia('(prefers-reduced-motion: reduce)');

/** Strip autoplay from opt-in carousels, and stop any that already started. */
function disableAutoplay() {
  if (!query.matches) return;

  for (const slideshow of document.querySelectorAll('.fine-carousel-autoplay slideshow-component')) {
    slideshow.removeAttribute('autoplay');
    // Defined by slideshow.js once the element upgrades; may not exist yet.
    if (typeof (/** @type {any} */ (slideshow).pause) === 'function') {
      /** @type {any} */ (slideshow).pause();
    }
  }
}

// Run as early as possible, then again once the DOM is parsed in case the
// carousel had not been rendered yet.
disableAutoplay();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', disableAutoplay, { once: true });
}

// Someone can change the preference mid-session.
query.addEventListener('change', disableAutoplay);
